import {
  Dashboard,
  Settings,
  SystemManagement,
  Seeker,
  CustomerManagement,
  Brandrequest,
  VendorManagement,
  OrderManagement,
  SubAdminManagement,
  ProductManagement,
  WarehouseManagement,
  Taxes,
  Groups,
  GroupTesting,
  Rating,
  Masters,
  Position,
  CarBrands,
  Currency,
} from "./Svg";

export const menu = [
  {
    name: "Dashboard",
    path: "/",
    Svg: Dashboard,
    subMenu: [],
    highlight: ["/my-profile", "/change-password"],
    subHighlight: [],
    key: "1",
  },
  {
    name: "Customer Management",
    path: "/customers",
    Svg: CustomerManagement,
    subMenu: [],
    highlight: ["/customer/add"],
    subHighlight: [
      "/customer/view",
      "/customer/edit",
      "/customer/change-password",
    ],
    key: "2",
  },
  {
    name: "Store Management",
    path: "/stores",
    Svg: VendorManagement,
    subMenu: [],
    highlight: ["/store/add"],
    subHighlight: [
      "/store/view",
      "/store/edit",
      // "/store/change-password",
    ],
    key: "3",
  },
  // {
  //   name: "Order Management",
  //   path: "/orders",
  //   Svg: OrderManagement,
  //   subMenu: [],
  //   highlight: ["/orders/add"],
  //   subHighlight: [
  //     "/orders/view",
  //     // "/orders/edit",
  //     // "/store/change-password",
  //   ],
  //   key: "3",
  // },
  
  {
    name: "Order Management",
    Svg: OrderManagement,
    subMenu: [
      {
        name: "Orders",
        path: "/orders",
        subMenu: [],
        highlight: [],
        subHighlight: [],
        key: "3_1",
      },
      {
        name: "Return Orders",
        path: "/return-orders",
        subMenu: [],
        highlight: [],
        subHighlight: [],
        key: "3_2",
      },
    ],
  },

  {
    name: "Offers",
    path: "/offers",
    Svg: OrderManagement,
    subMenu: [],
    highlight: ["/orders/add"],
    subHighlight: [
      "/offers/view",
      // "/orders/edit",
      // "/store/change-password",
    ],
    key: "3",
  },

  {
    name: "Transactions",
    Svg: Currency,
    subMenu: [
      {
        name: "Earnings",
        path: "/earnings",
        Svg: Currency,
        subMenu: [],
        highlight: [],
        subHighlight: [],
        key: "4",
      },
      {
        name: "Payment history",
        path: "/payment-history",
        Svg: Currency,
        subMenu: [],
        highlight: [],
        subHighlight: [],
        key: "5",
      },

      {
        name: "Vendor Earnings",
        path: "/vendor-earning",
        // Svg: Currency,
        subMenu: [],
        highlight: [],
        subHighlight: [],
        key: "5",
      },
    ],
    // highlight: ["/position/add"],
    // subHighlight: ["/position/view", "/position/edit"],
    // key: "5",
  },
  // {
  //   name: "Sub Admin Management",
  //   Svg: SubAdminManagement,
  //   subMenu: [
  //     {
  //       name: "Sub Admin",
  //       path: "/sub-admins",
  //       highlight: ["/sub-admin/add"],
  //       subHighlight: [
  //         "/sub-admin/view",
  //         "/sub-admin/edit",
  //         "/sub-admin/change-password",
  //       ],
  //       key: "4_1",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Admin Roles",
  //       path: "/admin-roles",
  //       highlight: ["/admin-role/add"],
  //       subHighlight: ["/admin-role/view", "/admin-role/edit"],
  //       key: "4_20",
  //       subMenu: [],
  //     },
  //   ],
  //   highlight: ["/sub-admin/add", "/admin-role/add"],
  //   subHighlight: [
  //     "/sub-admin/view",
  //     "/sub-admin/edit",
  //     "/sub-admin/change-password",
  //     "/admin-role/view",
  //     "/admin-role/edit",
  //   ],
  //   key: "4",
  // },

  {
    name: "Brand Requests",
    path: "/brand-request",
    Svg: Brandrequest,
    subMenu: [],
    highlight: ["/brand-request/view"],
    subHighlight: [],
    key: "12",
  },

  {
    name: "Masters",
    Svg: Masters,
    subMenu: [
      {
        name: "Cities",
        path: "/cities",
        subMenu: [],
        highlight: ["/cities/add"],
        subHighlight: ["/cities/edit", "/cities/view"],
        key: "5_22",
      },
      {
        name: "Vendor User Position Management",
        path: "/positions",
        Svg: Position,
        subMenu: [],
        highlight: ["/position/add"],
        subHighlight: ["/position/view", "/position/edit"],
        key: "5_1",
      },
      {
        name: "Brands",
        path: "/brands",
        Svg: Position,
        subMenu: [],
        highlight: ["/brands/add"],
        subHighlight: ["/brands/view", "/brands/edit"],
        key: "5_11",
      },
      {
        name: "Spare Side",
        path: "/spare-side",
        Svg: Position,
        subMenu: [],
        highlight: ["/spare-side/add"],
        subHighlight: ["/spare-side/edit"],
        key: "",
      },
    ],
    // highlight: ["/position/add"],
    // subHighlight: ["/position/view", "/position/edit"],
    // key: "5",
  },

  // {
  //   name: "Group",
  //   Svg: GroupTesting,
  //   subMenu: [
  //     {
  //       name: "Vendors",
  //       path: "/group/vendors",
  //       highlight: ["/group/vendor/add"],
  //       subHighlight: ["/group/vendor/edit", "/group/vendor/view"],
  //       key: "31_21",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Countries",
  //       path: "/group/countries",
  //       highlight: ["/group/country/add"],
  //       subHighlight: ["/group/country/edit", "/group/country/view"],

  //       key: "31_22",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Customers",
  //       path: "/group/customers",
  //       highlight: ["/group/customer/add"],
  //       subHighlight: ["/group/customer/edit", "/group/customer/view"],
  //       key: "31_23",
  //       subMenu: [],
  //     },

  //     {
  //       name: "Suppliers",
  //       path: "/group/suppliers",
  //       highlight: ["/group/supplier/add"],
  //       subHighlight: ["/group/supplier/edit", "/group/supplier/view"],
  //       key: "31_24",
  //       subMenu: [],
  //     },

  //     {
  //       name: "Products ",
  //       path: "/group/products",
  //       highlight: ["/group/product/add"],
  //       subHighlight: ["/group/product/edit", "/group/product/view"],
  //       key: "31_25",
  //       subMenu: [],
  //     },
  //   ],
  //   highlight: [
  //     "/group/vendor/add",
  //     "/group/country/add",
  //     "/group/customer/add",
  //     "/group/supplier/add",
  //     "/group/product/add",
  //   ],
  //   subHighlight: [
  //     "/group/vendor/edit",
  //     "/group/vendor/view",
  //     "/group/country/edit",
  //     "/group/country/view",
  //     "/group/customer/edit",
  //     "/group/customer/view",
  //     "/group/supplier/edit",
  //     "/group/supplier/view",
  //     "/group/product/edit",
  //     "/group/product/view",
  //   ],
  //   key: "31",
  // },
  // {
  //   name: "Home Page Management",
  //   Svg: ProductManagement,
  //   subMenu: [
  //     {
  //       name: "Section One",
  //       path: "/section-one/sliders",
  //       highlight: [
  //         "/section-one/sliders",
  //         "/section-one",
  //         "/section-one/slider/add",
  //       ],
  //       subHighlight: ["/section-one/slider/edit"],
  //       key: "13_1",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Section Two",
  //       path: "/section-two",
  //       highlight: ["/section-two", "/section-two/add"],
  //       subHighlight: ["/section-two/edit"],
  //       key: "13_1",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Section Three",
  //       path: "/section-three",
  //       highlight: ["/section-three", "/section-three/add"],
  //       subHighlight: ["/section-three/edit"],
  //       key: "13_1",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Section Four",
  //       path: "/section-four",
  //       highlight: ["/section-four"],
  //       subHighlight: [],
  //       key: "13_1",
  //       subMenu: [],
  //     },
  //     {
  //       name: "Section Five",
  //       path: "/section-five",
  //       highlight: ["/section-five"],
  //       subHighlight: [],
  //       key: "13_1",
  //       subMenu: [],
  //     },
  //   ],
  //   highlight: [
  //     "/section-one/sliders",
  //     "/section-one",
  //     "/section-one/slider/add",
  //     "/section-two",
  //     "/section-two/add",
  //     "/section-three",
  //     "/section-three/add",
  //     "/section-four",
  //   ],
  //   subHighlight: [
  //     "/section-one/slider/edit",
  //     "/section-two/edit",
  //     "/section-three/edit",
  //   ],
  //   key: "13",
  // },

  {
    name: "System Management",
    Svg: SystemManagement,
    subMenu: [
      {
        name: "Cms Pages",
        path: "/cms",
        highlight: ["/cms/add"],
        subHighlight: ["/cms/view", "/cms/edit"],
        key: "12_1",
        subMenu: [],
      },
      // {
      //   name: "Seo Pages",
      //   path: "/seo-pages",
      //   highlight: ["/seo-page/add"],
      //   subHighlight: ["/seo-page/edit"],
      //   key: "12_10",
      //   subMenu: [],
      // },
      {
        name: "Email Templates",
        path: "/email-template",
        highlight: ["/email-template/add"],
        subHighlight: ["/email-template/edit"],
        key: "12_20",
        subMenu: [],
      },
      {
        name: "Email Logs",
        path: "/email-logs",
        highlight: [],
        subHighlight: [],
        key: "12_30",
        subMenu: [],
      },
      {
        name: "Notification Templates",
        path: "/notification-template",
        highlight: ["/notification-template/add"],
        subHighlight: ["/notification-template/edit"],
        key: "12_60",
        subMenu: [],
      },
      {
        name: "Custom Notifications",
        path: "/custom-notification",
        highlight: ["/custom-notification/send"],
        subHighlight: ["/custom-notification/log"],
        key: "12_612",
        subMenu: [],
      },
      {
        name: "FAQs",
        path: "/faq",
        highlight: ["/faq/add"],
        subHighlight: ["/faq/edit", "/faq/view"],
        key: "12_40",
        subMenu: [],
      },
      // {
      //   name: "Languages",
      //   path: "/languages",
      //   highlight: ["/language/add"],
      //   subHighlight: [],
      //   key: "12_140",
      //   subMenu: [],
      // },

      {
        name: "Contact Us",
        path: "/contact-us",
        highlight: [],
        subHighlight: [],
        key: "12_200",
        subMenu: [],
      },

      {
        name: "Home Page Management",
        path: "/home-page",
        subMenu: [],
        highlight: ["/home-page/add"],
        subHighlight: ["/home-page/view", "/home-page/edit"],
      },
    ],
    highlight: [
      "/setting/prefix/Payment",
      "/system-images/add",
      "/country/add",
    ],
    subHighlight: [
      "/system-images/edit",
      "/seo-page/edit",
      "/country/edit",
      "/cities",
      "/taxes",
    ],
    key: "12",
  },
  {
    name: "Settings",
    Svg: Settings,
    subMenu: [
      {
        name: "Site Setting",
        path: "/setting/prefix/Site",
        highlight: [],
        subHighlight: [],
        subMenu: [],
        key: "13_2",
      },
      {
        name: "Reading Setting",
        path: "/setting/prefix/Reading",
        key: "13_3",
        highlight: [],
        subHighlight: [],
        subMenu: [],
      },
      {
        name: "Social Setting",
        path: "/setting/prefix/Social",
        key: "13_4",
        highlight: [],
        subHighlight: [],
        subMenu: [],
      },
      {
        name: "Contact Setting",
        path: "/setting/prefix/Contact",
        key: "13_5",
        highlight: [],
        subHighlight: [],
        subMenu: [],
      },
      {
        name: "Commission Setting",
        path: "/setting/prefix/Commission",
        key: "13_6",
        highlight: [],
        subHighlight: [],
        subMenu: [],
      },
      {
        name: "Checkout Setting",
        path: "/setting/prefix/Checkout",
        key: "13_1",
        highlight: [],
        subHighlight: [],
        subMenu: [],
      },
      {
        name: "Video Setting",
        path: "/setting/prefix/Video",
        key: "13_7",
        highlight: [],
        subHighlight: [],
        subMenu: [],
      },
    ],
    highlight: ["/setting", "/setting/add", "/employee-count/add"],
    subHighlight: ["/setting/edit", "/employee-count/edit"],
    key: "13",
  },
];
